import React from 'react'
import classNames from 'classnames'
import BootstrapTable from 'react-bootstrap-table-next'

export default class RunObjectResultGrid extends React.Component {
  render() {

    const {objects} = this.props

    if(!objects)
    {
      console.log("ERROR: objects are NULL in returned results");
    }

    const fieldColumns = [{
      dataField: 'value',
      text: 'Value',
      sort: true
    }];
    const fields = objects.filter(obj => obj["objectType"] == "field")


    const tables = objects.filter(obj => obj["objectType"] == "table").map(table => {
      let data = undefined;
      let columns = undefined;
      try{
      columns = Object.keys(table["rows"][0]).map(key => {
        return {
          dataField: key,
          text: key,
          sort: true
        }
      })
      data = table["rows"].map((row, index) => {
        var rowData = {}
        for (let [key, value] of Object.entries(row)) {
          rowData[key] = value["value"]
        }
        rowData["key"] = index;

        return rowData
      })
    }
    catch(e)
    {
      console.log(`Error result grid: ${e}`);
    }

    if (data && data.length){

      return (
        <div className="run-template-result-grid-table text-left">
          <h3 className="mB-10 pull-left"><code>{table["name"]}</code> <small><code>{data && data.length}</code> rows, <code>{columns && columns.length}</code> columns</small></h3>
          <BootstrapTable keyField='key' data={data} columns={columns} />
        </div>
      )
    }
    else {

      return (
        <div className="run-template-result-grid-table text-left">
        <h3 className="mB-10 pull-left"><code>{table["name"]}</code> <small> no rows found</small></h3>
          <div></div>
        </div>
      )

      
    }

    })

    const fieldsClassNames = classNames("run-template-result-grid-fields", {hidden: fields.length == 0})

    return (
      <div className="run-template-result-grid text-left">
        <div className={fieldsClassNames}>
          {fields && fields[0] && fields[0]["value"]}
        </div>
        {tables}
      </div>
    );
  }
}
